import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addSize({ dispatch, commit }, size) {
    try {
      const { data } = await request.post('sizes', size);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
